/* eslint-disable no-console */
import sendPostMessage from 'utils/sendPostMessage';

import { getTagsDomain } from '../utils';

class GtmSDK {
  _eventQueue = []; // Queue for events before initialization
  _isInitialized = false; // Whether the GTM iframe is initialized
  _gtmIframeRef = null; // Reference to the GTM iframe

  // Public: Register the GTM iframe reference
  registerIframe(ref) {
    this._gtmIframeRef = ref;
  }

  // Public: Initialize GTM and process queued events
  initializeGtm() {
    if (this._isInitialized) {
      return;
    }

    console.log('Initializing GTM...');
    this._directSendEvent('init');
    this._isInitialized = true;

    // Process queued events
    while (this._eventQueue.length > 0) {
      const { message, data } = this._eventQueue.shift();
      this._directSendEvent(message, data); // Send all queued events
    }
  }

  // Public: Send an event or queue it if not initialized
  sendEvent(message, data) {
    if (this._isInitialized) {
      this._directSendEvent(message, data); // Send immediately if initialized
    } else {
      this._eventQueue.push({ message, data }); // Queue the event
    }
  }

  // Internal: Send a single event to the GTM iframe
  _directSendEvent(message, data) {
    if (this._gtmIframeRef?.current?.contentWindow) {
      const tagsDomain = getTagsDomain();
      const baseProperties = {
        windowState: window.history.state,
        path: window.location.pathname,
        type: 'gtm-analytics',
      };

      const combinedData = { ...baseProperties, ...data };
      sendPostMessage(
        this._gtmIframeRef.current.contentWindow,
        { message, properties: combinedData },
        tagsDomain
      );
    } else {
      console.warn('GTM iframe is not available to send event');
    }
  }
}

export const gtmSDK = new GtmSDK();
